"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionHaveCallBack = exports.Action = void 0;
exports.Action = {
    //Zalo
    getdownloadedsticker: "action.get.downloaded.sticker",
    opensharesticker: "action.open.share.sticker",
    openprofile: "action.open.profile",
    openfeeddetail: "action.open.feeddetail",
    openfriendrada: "action.open.friendrada",
    openinapp: "action.open.inapp",
    openoutapp: "action.open.outapp",
    openpage: "action.open.page",
    openphotodetail: "action.open.photodetail",
    opengalary: "action.open.galary",
    opengamecenter: "action.open.gamecenter",
    opengamenews: "action.open.gamenews",
    opentabcontact: "action.open.tab.contact",
    opentabsocial: "action.open.tab.social",
    openfriendsuggest: "action.open.friendsuggest",
    opengrouplist: "action.open.grouplist",
    opennearby: "action.open.nearby",
    openroom: "action.open.room",
    openstickerstore: "action.open.stickerstore",
    opencreatechat: "action.open.createchat",
    copylinkcatesticker: "action.copy.link.catesticker",
    requestbuysticker: "action.request.buy.sticker",
    openchat: "action.open.chat",
    opentabchat: "action.open.tab.chat",
    openChatGroup: "action.open.chatgroup",
    openaddfriend: "action.open.addfriend",
    opentabmore: "action.open.tab.more",
    openpostfeed: "action.open.postfeed",
    openlogindevices: "action.open.logindevices",
    opensendsticker: "action.open.sendsticker",
    reportabuse: "action.report.abuse",
    followoa: "action.follow.oa",
    unfollowoa: "action.unfollow.oa",
    opengamedetail: "action.open.gamedetail",
    opensharesheet: "action.open.sharesheet",
    requestcamera: "action.request.permission.camera",
    //Webview
    changetitleheader: "action.change.title.header",
    clearcachewebview: "action.webview.clearcache",
    confirmcache: "action.webview.confirmcache",
    isvisible: "action.webview.isvisible",
    networktype: "action.webview.networktype",
    changebuttonheader: "action.change.button.header",
    createoptionmenu: "action.create.options.menu",
    createshortcut: "action.create.shortcut",
    changeleftbuttonbar: "action.change.actionbar.leftbutton.type",
    closewindow: "action.window.close",
    checkResError: "action.webview.checkResError",
    requestPayment: "action.iap.requestpayment",
    getzbrowserstats: "action.zbrowser.getstats",
    jsbridge: "action.zbrowser.jsbridge",
    bioauthen: "action.prompt.authentication",
    changeColorHeader: "action.change.actionbar.color",
    checkStateAuthen: "action.prompt.authentication.check_state",
    //Device
    openappstore: "action.open.appstore",
    getlocation: "action.get.location",
    querylocationhide: "action.query.location.hide",
    showtoast: "action.show.toast",
    openapp: "action.open.app",
    hidekeyboard: "action.hide.keyboard",
    openphone: "action.open.phone",
    openqr: "action.open.qr",
    opensms: "action.open.sms",
    viewqr: "action.view.myqr",
    keepscreen: "action.keep.screen",
    autorotate: "action.change.autorotate",
    //Misc
    checkappinstalled: "action.check.app.installed",
    queryshow: "action.query.show",
    queryhide: "action.query.hide",
    openinapprw: "action.open.inapprw",
    gettrackingstatus: "action.zalorun.getTrackingStatus",
    settrackingstatus: "action.zalorun.setTrackingStatus",
    getdaystep: "action.zalorun.getDayStep",
    forcesubmitdata: "action.zalorun.forceSubmitData",
    setweight: "action.zalorun.setWeight",
    getAdIdClient: "action.get.adidclient",
    openProfileExt: "action.open.profile.ext",
    downloadcate: "action.download.cate",
    login: "action.jump.login",
    openInterstitialAds: "action.open.adtima.ads.interstitial",
    openRewardAds: "action.open.adtima.ads",
    openAdtimaAds: "action.open.adtima.ads",
    getAdsID: "action.get.adidclient",
    open_mp: "action.open.mp"
};
exports.ActionHaveCallBack = [
    exports.Action.getdownloadedsticker,
    exports.Action.reportabuse,
    exports.Action.followoa,
    exports.Action.unfollowoa,
    exports.Action.opensharesheet,
    exports.Action.createoptionmenu,
    exports.Action.changeleftbuttonbar,
    exports.Action.closewindow,
    exports.Action.jsbridge,
    exports.Action.getlocation,
    exports.Action.querylocationhide,
    exports.Action.showtoast,
    exports.Action.viewqr,
    exports.Action.keepscreen,
    exports.Action.gettrackingstatus,
    exports.Action.settrackingstatus,
    exports.Action.getdaystep,
    exports.Action.forcesubmitdata,
    exports.Action.setweight,
    exports.Action.downloadcate,
];
exports.default = {};
